export enum AccountKYCStatusEnum {
  KYC_VERIFIED = 'kyc_verified',
  AML_VERIFIED = 'aml_verified',
  UNVERIFIED = 'unverified',
  FAILED = 'failed',
}
